import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Alert, { AlertLink } from './bootstrap/Alert';
import AuthContext from '../contexts/authContext';
import Icon from './icon/Icon';
import Button from './bootstrap/Button';

const EmailVerificationAlert = () => {
	const { userData } = useContext(AuthContext);
	const navigate = useNavigate();
	const [isDismissed, setIsDismissed] = useState(false);

	// Check session storage to see if user dismissed it in this session
	useEffect(() => {
		const dismissed = sessionStorage.getItem('email_verification_dismissed');
		if (dismissed === 'true') {
			setIsDismissed(true);
		}
	}, []);

	// If user is not logged in, or already verified, or dismissed the alert, don't show it.
	if (!userData || Object.keys(userData).length === 0 || userData.email_activation === 1 || isDismissed) {
		return null;
	}

	const handleDismiss = () => {
		setIsDismissed(true);
		sessionStorage.setItem('email_verification_dismissed', 'true');
	};

	return (
		<div className='container-fluid mt-5 mt-md-2 mb-3 mx-3'>
			<Alert
				color='warning'
				isLight
				icon='Verified'
				isDismissible
				onDismiss={handleDismiss}
				className='mb-0 shadow-sm py-2 py-md-3'>
				<div className='row align-items-center g-2'>
					<div className='col-12 col-md'>
						<strong className='d-block d-md-inline me-1'>E-posta Doğrulaması!</strong>
						Bildirimleri alabilmek için e-postanızı doğrulayın.
					</div>
					<div className='col-12 col-md-auto'>
						<AlertLink
							className='cursor-pointer fw-bold text-decoration-none d-inline-flex align-items-center'
							onClick={() => navigate('/profile/account')}>
							Profilime Git <Icon icon='ChevronRight' size='sm' className='ms-1' />
						</AlertLink>
					</div>
				</div>
			</Alert>
		</div>
	);
};

export default EmailVerificationAlert;
